<nz-select
  (ngModelChange)="onSelect($event)"
  [compareWith]="compareOrgUnitFn"
  [ngModel]="value"
  [nzDisabled]="disabled"
  [nzPlaceHolder]="placeholder"
  [nzShowArrow]="true"
  nzAllowClear
  nzShowSearch
>
  @for (orgUnit of organizationalUnits$ | async; track orgUnit.id) {
    <nz-option [nzValue]="orgUnit.id" [nzLabel]="orgUnit.name"></nz-option>
  }
</nz-select>
